// extracted by mini-css-extract-plugin
var _1 = "ExpandedPostModal-module__seriesFooterContainer--e6jmE";
export { _1 as "seriesFooterContainer" }
